import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgToolCampaign = (props) => /* @__PURE__ */ _jsx("svg", {
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "m11.523 11.078-8.018-5.13v10.276a.3.3 0 0 0 .087.222.3.3 0 0 0 .222.085h8.963v1.505H3.813c-.507 0-.936-.176-1.286-.527A1.749 1.749 0 0 1 2 16.225V4.81c0-.506.176-.935.527-1.285A1.749 1.749 0 0 1 3.812 3h15.421c.506 0 .934.176 1.286.527.35.35.526.779.526 1.286v6.958H19.54V5.95l-8.018 5.129Zm0-1.562 7.866-5.011H3.657l7.866 5.01Zm6.824 11.422L17.3 19.89l1.82-1.855h-4.53v-1.503h4.541l-1.855-1.854 1.072-1.047L22 17.285l-3.653 3.653ZM3.504 5.949v11.422-5.6.122-7.388 1.444Z",
		fill: "currentColor"
	})
});
export default SvgToolCampaign;
